module.exports = __webpack_public_path__ + "img/galaxy_purple_print.e0b3d98f.png";